<template>
  <div class="auditHistoryTbl">
    <h1 @click="recentVisible = !recentVisible" class="recent-updates-label">
      <a>Recent Updates</a>
      <font-awesome-icon :icon="expandStateIcon" class="float-right margin-point-4rem" />
    </h1>
    <b-collapse id="recent-updates" v-model="recentVisible">
      <b-card>
        <ul class="basic-info">
          <li>
            <b class="label">Last Login:</b>
            {{recentInfo.lastLogin}}
          </li>
          <li>
            <b class="label">Last Modified By:</b>
            {{recentInfo.lastModifiedBy}}
          </li>
          <li>
            <b class="label">Last Modified Date:</b>
            {{recentInfo.lastModifiedDate}}
          </li>
          <li>
            <b class="label">Created By:</b>
            {{recentInfo.createdBy}}
          </li>
          <!-- <li>
                      <b>Created Date:</b>
                      {{recentInfo.createdDate}}
          </li>-->
        </ul>
      </b-card>
    </b-collapse>
    <h1 class="audit-history-label">Audit History</h1>
    <div class="audit-date-filter mb-2">
      <label class="audit-date-label" for="auditStartDate">Start Date</label>
      <vDatePicker
        :input-attr="{ id: 'auditStartDate' }"
        v-model:value="startDate"
        @change="changefilter()"
        @clear="changefilter()"
      ></vDatePicker>
      <label class="audit-date-label" for="auditEndDate">End Date</label>
      <vDatePicker
        :input-attr="{ id: 'auditEndDate' }"
        v-model:value="endDate"
        @change="changefilter()"
        @clear="changefilter()"
      ></vDatePicker>
    </div>
    <b-table
      ref="auditHistoryTable"
      id="AuditHistoryTable"
      striped
      no-border-collapse
      sticky-header
      head-variant="head-border"
      :show-empty="showempty"
      :busy="isBusy"
      :items="filterdlogEntries"
      :fields="columnsfield"
      :per-page="perPage"
      :current-page="currentPage"
      responsive
      class="tableTextColor"
    >
      <template v-slot:table-busy>
        <div class="text-center">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:cell(eventDate)="data">
        <a
          v-on:click="auditLoginfo(data)"
          class="link"
          :title="formateGridDate(data.value)"
        >{{formateGridDate(data.value)}}</a>
      </template>
      <template v-slot:cell(accountNo)="data">
        <span :title="data.value">{{data.value}}</span>
      </template>
      <template v-slot:cell(eventDescription)="data">
          <span :title="data.value">{{data.value}}</span>
      </template>
      <template v-slot:cell(eventAddedBy)="data">
        <span :title="data.value">{{data.value}}</span>
      </template>
      <!--<template v-slot:cell(ipAddress)="data">
                <span :title="data.value">{{data.value}}</span>
            </template>
            <template v-slot:cell(browser)="data">
                <span :title="data.value">{{data.value}}</span>
      </template>-->
      <template v-slot:cell(fieldChanged)="data">
        <span :title="data.value">{{data.value}}</span>
      </template>
      <template v-slot:cell(priorValue)="data">
        <span :title="data.value">{{data.value}}</span>
      </template>
      <template v-slot:cell(newValue)="data">
        <span :title="data.value">{{data.value}}</span>
      </template>
    </b-table>
    <b-modal id="AuditinfoModal" size="lg"
             no-close-on-esc 
             no-close-on-backdrop>
      <template #modal-header>
        <h5 class="modal-title">Event Log</h5>
      </template>
      <template #default>
    <div class="container">
        <div class="mb-3">
          <table>
            <colgroup>
              <col class="event-log-col-w20" />
              <col class="event-log-col-w20" />
              <col class="event-log-col-w20" />
              <col class="event-log-col-w20" />
              <col class="event-log-col-w20" />
              <col class="event-log-col-w20" />
            </colgroup>
            <thead>
              <tr class="event-log-row-h40">
                <th>Event Id</th>
                <td>{{infoModal.title}}</td>
                <th>User</th>
                <td>{{userName}}</td>
              </tr>
              <tr class="event-log-row-h40">
                <th>Event Date</th>
                <td>{{infoModal.EventDate}}</td>
                <th>Account#</th>
                <td>{{infoModal.Account}}</td>
              </tr>
              <tr class="event-log-row-h40">
                <th>Event Type</th>
                <td>{{infoModal.eventTypeDescription}}</td>
                <th>Operator</th>
                <td>{{infoModal.Operator}}</td>
              </tr>
              <tr class="event-log-row-h40">
                <th>Browser</th>
                <td>{{infoModal.Browser}}</td>
                <th>IP Address</th>
                <td>{{infoModal.IpAddress}}</td>
              </tr>

              <tr class="event-log-row-h40">
                <th>Prior Value</th>
                <td>{{infoModal.priorValue}}</td>
                <th>New Value</th>
                <td>{{infoModal.newValue}}</td>
              </tr>
              <tr class="event-log-row-h40">
                <th>Field Changed</th>
                <td>{{infoModal.FieldChange}}</td>
                <th>Event Note</th>
                <td>{{infoModal.EventNote}}</td>
              </tr>
            </thead>
          </table>
          <div class="clear-both"></div>
        </div>
      </div>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button class="um-btn" @click="CloseAuditLogDetail()">Ok</b-button>
      </template>
    </b-modal>
    <div class="float-right">
      <span class="paginationCurrentPage me-2 mt-1">Current page: {{currentPage}}</span>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="AuditHistoryTable"
        align="right"
        size="sm"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
//import service from "../../services/api.services";
import vDatePicker from "vue-datepicker-next";
import "vue-datepicker-next/locale/en";
import "vue-datepicker-next/index.css";
export default {
  name: "AuditHistory",
  components: {
    vDatePicker
  },
  data() {
    return {
      recentInfo: {},
      logEntries: [],
      isBusy: true,
      showempty: true,
      fixed: true,
      perPage: 10,
      currentPage: 1,
      bordered: true,
      height: "",
      recentVisible: true,
      startDate: "",
      endDate: "",
      filterdlogEntries: [],
      infoModal: {
        id: "info-modal",
        title: "",
        EventDate: "",
        Account: "",
        Operator: "",
        Browser: "",
        FieldChange: "",
        IpAddress: "",
        priorValue: "",
        newValue: "",
        EventName: "",
        EventTypeDescription: "",
        EventNote: ""
      }
    };
  },
  computed: {
    expandStateIcon() {
      return this.recentVisible ? "minus-circle" : "plus-circle";
    },
    rows() {
      return this.filterdlogEntries.length;
    },
    columnsfield: function() {
      var fields = [
        {
          label: "Event Date",
          key: "eventDate",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-3"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-3", "audit-history-thClass"]
        },
        {
          label: "Account#",
          key: "accountNo",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-1"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-1", "audit-history-thClass"]
        },
        {
          label: "Event Type",
          key: "eventTypeDescription",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-2"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-3", "audit-history-thClass"]
        },
        {
          label: "Operator",
          key: "eventAddedBy",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-1"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-1", "audit-history-thClass"]
        },
        {
          label: "Field Changed",
          key: "fieldChanged",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-3"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-3", "audit-history-thClass"]
        },
        {
          label: "Prior Value",
          key: "priorValue",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-1"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-1", "audit-history-thClass"]
        },
        {
          label: "New Value",
          key: "newValue",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-1"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-1", "audit-history-thClass"]
        }
      ];
      return fields;
    }
  },
  props: {
    editingUserauditHistory: {},
    userName: String
  },
  created() {
    window.addEventListener("resize", this.handleHeightResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleHeightResize);
  },
  mounted() {
    this.getAuditHistory();
    this.handleHeightResize();
  },
  methods: {
    auditLoginfo: function(item) {
      //console.log(item);
      this.infoModal.EventDate = this.formateGridDate(item.item.eventDate);
      this.infoModal.Account = item.item.accountNo;
      this.infoModal.Operator = item.item.eventAddedBy;
      this.infoModal.Browser = item.item.browser;
      this.infoModal.IpAddress = item.item.ipAddress;
      this.infoModal.IpAddress = item.item.ipAddress;
      this.infoModal.newValue = item.item.newValue;
      this.infoModal.priorValue = item.item.priorValue;
      this.infoModal.EventName = item.item.eventName;
      this.infoModal.FieldChange = item.item.fieldChanged;
      this.infoModal.title = item.item.eventHistoryID;
      this.infoModal.eventTypeDescription = item.item.eventTypeDescription;
      this.infoModal.EventNote = item.item.eventNote;
      this.$bvModal.show("AuditinfoModal");
    },
    CloseAuditLogDetail: function() {
      this.$bvModal.hide("AuditinfoModal");
    },

    getAuditHistory: function() {
      var that = this;
      if (that.editingUserauditHistory != null) {
        that.recentInfo = that.editingUserauditHistory.recentInfo;
          that.logEntries = that.editingUserauditHistory.auditLogDetails;
        that.filterdlogEntries = that.logEntries;
      }
      that.isBusy = false;
    },
    handleHeightResize() {
      this.height =
        window.innerHeight -
        this.$refs.auditHistoryTable.offsetTop -
        100 +
        "px";
    },
    changefilter: function() {
      this.filterAugitLog();
    },
    filterAugitLog: function() {
      if (
        (this.startDate == undefined ||
          this.startDate == "" ||
          this.startDate == null) &&
        (this.endDate == "" ||
          this.endDate == null ||
          this.endDate == undefined)
      ) {
        this.filterdlogEntries = this.logEntries;
      } else if (
        this.startDate === null ||
        (this.startDate == "" && this.endDate != "")
      ) {
        this.filterdlogEntries = this.logEntries.filter(x => {
          return (
            new Date(this.formateDate(this.endDate)) >=
            new Date(this.formateDate(x.eventDate))
          );
        });
      } else if (
        this.endDate === null ||
        (this.endDate == "" && this.startDate != "")
      ) {
        this.filterdlogEntries = this.logEntries.filter(x => {
          return (
            new Date(this.formateDate(x.eventDate)) >=
            new Date(this.formateDate(this.startDate))
          );
        });
      } else {
        this.filterdlogEntries = this.logEntries.filter(x => {
          return (
            new Date(this.formateDate(x.eventDate)) >=
              new Date(this.formateDate(this.startDate)) &&
            new Date(this.formateDate(this.endDate)) >=
              new Date(this.formateDate(x.eventDate))
          );
        });
      }
    },
    formateDate: function(validDate) {
      const dateObj = new Date(validDate);
      const year = dateObj.getFullYear();
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
      const date = dateObj
        .getDate()
        .toString()
        .padStart(2, "0");

      return year + "-" + month + "-" + date;
    },
    formateGridDate: function(validDate) {
      const dateObj = new Date(validDate);
      var hours = dateObj.getHours();
      var minutes = dateObj.getMinutes();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var gridDate =
        ("00" + (dateObj.getMonth() + 1)).slice(-2) +
        "/" +
        ("00" + dateObj.getDate()).slice(-2) +
        "/" +
        dateObj.getFullYear() +
        " " +
        ("00" + hours).slice(-2) +
        ":" +
        ("00" + minutes).slice(-2) +
        ":" +
        ("00" + dateObj.getSeconds()).slice(-2) +
        " " +
        ampm;
      return gridDate;
    }
  }
};
</script>

<style scoped>
  .event-log-col-w20 {
    width: 20%;
  }

  .event-log-row-h40 {
    height: 40px;
  }
</style>